import React from 'react';

/**
 * Shown at end-shift when the cashier still has parked carts (option C). Keep
 * leaves them as in_progress per-cashier — they repopulate the tray on next
 * login; Discard removes them. Rendered only when count > 0; the parent gates
 * on end-shift so it never appears mid-sale.
 */
interface Props {
  count: number;
  onKeep: () => void;
  onDiscard: () => void;
}

export const ShiftCloseParkedPrompt: React.FC<Props> = ({ count, onKeep, onDiscard }) => {
  if (count <= 0) return null;
  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000,
      }}
    >
      <div
        data-testid="shift-close-parked-prompt"
        style={{ background: '#fff', borderRadius: 10, padding: 24, maxWidth: 420, width: '90%' }}
      >
        <h3 style={{ marginTop: 0 }}>Parked carts</h3>
        <p style={{ fontSize: 15 }}>
          You have <strong>{count}</strong> parked cart{count === 1 ? '' : 's'} — keep or discard?
        </p>
        <p style={{ fontSize: 13, color: '#666' }}>
          Keep leaves them for your next login. Discard removes them.
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button
            onClick={onKeep}
            style={{ flex: 1, padding: '10px', borderRadius: 6, border: '2px solid #1a4d1a', background: '#fff', color: '#1a4d1a', fontWeight: 700, cursor: 'pointer' }}
          >
            Keep them
          </button>
          <button
            onClick={onDiscard}
            style={{ flex: 1, padding: '10px', borderRadius: 6, border: 'none', background: '#b91c1c', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
          >
            Discard all
          </button>
        </div>
      </div>
    </div>
  );
};
